module.exports = __webpack_public_path__ + "img/hc.35e4ee55.png";